export default __webpack_public_path__ + "static/media/mdi_secure.2b1db19a.svg";